export const getRegex = (questionId: string) => {
  return new RegExp(`<div id="${questionId}">(.*?)<\/div>`, 's');
};
